import axios, { AxiosRequestConfig } from 'axios';
// import axiosRetry from 'axios-retry';
import { API_ROOT, API_ROOT_USER, DECRYPT_KEY, API_ROOT_ADMIN } from 'enviroments';
import { decryptUtils } from 'utils';
import { _getToken, _removeToken } from 'utils/cookie-token';

const accessToken = _getToken();

const client = axios.create({
  baseURL: `${API_ROOT}`,
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// axiosRetry(client, {
//   retries: 3,
//   retryDelay: (retryCount) => {
//     return retryCount * 1000;
//   }
// });

// Add a request interceptor
client.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    if (accessToken) {
      config.headers!['X-Authorization'] = accessToken;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Add a response interceptor
client.interceptors.response.use(
  function (response) {
    try {
      response.data = DECRYPT_KEY
        ? decryptUtils(response.data?.data || response.data, DECRYPT_KEY)
        : response.data;
      return response;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  function (error) {
    if (error.response) {
      error.response.data = DECRYPT_KEY
        ? decryptUtils(error.response?.data?.data || error.response.data, DECRYPT_KEY)
        : error.response.data;
      if (error?.response?.data?.code === 'FORBIDDEN') {
        _removeToken();
        window.location.href = '/login';
      }

      if (
        error?.response?.data?.code === 'UNAUTHORIZED' ||
        error?.response?.data?.code === 'TOKEN_EXPIRED'
      ) {
        _removeToken();
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

const clientUser = axios.create({
  baseURL: `${API_ROOT_USER}`,
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add a request interceptor
clientUser.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    if (accessToken) {
      config.headers!['X-Authorization'] = accessToken;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

clientUser.interceptors.response.use(
  function (response) {
    try {
      response.data = DECRYPT_KEY
        ? decryptUtils(response.data?.data || response.data, DECRYPT_KEY)
        : response.data;
      return response;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  function (error) {
    if (error.response) {
      error.response.data = DECRYPT_KEY
        ? decryptUtils(error.response?.data?.data || error.response.data, DECRYPT_KEY)
        : error.response.data;
      if (error?.response?.data?.code === 'FORBIDDEN') {
        _removeToken();
        window.location.href = '/login';
      }

      if (
        error?.response?.data?.code === 'UNAUTHORIZED' ||
        error?.response?.data?.code === 'TOKEN_EXPIRED'
      ) {
        _removeToken();
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

//Admin
const clientAdmin = axios.create({
  baseURL: `${API_ROOT_ADMIN}`,
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add a request interceptor
clientAdmin.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    if (accessToken) {
      config.headers!['X-Authorization'] = accessToken;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

clientAdmin.interceptors.response.use(
  function (response) {
    try {
      response.data = DECRYPT_KEY
        ? decryptUtils(response.data?.data || response.data, DECRYPT_KEY)
        : response.data;
      return response;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },
  function (error) {
    if (error.response) {
      error.response.data = DECRYPT_KEY
        ? decryptUtils(error.response?.data?.data || error.response.data, DECRYPT_KEY)
        : error.response.data;
      if (error?.response?.data?.code === 'FORBIDDEN') {
        _removeToken();
        window.location.href = '/login';
      }

      if (
        error?.response?.data?.code === 'UNAUTHORIZED' ||
        error?.response?.data?.code === 'TOKEN_EXPIRED'
      ) {
        _removeToken();
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export { client, clientUser, clientAdmin };
